export const REVIEW_PAGE_SIZE = 5;
export const REVIEW_MINIMUM_THRESHOLD = 20;
